// Default form state and errors for organization forms
import { defaultOrganizationFormValues, IEntrataUser } from '@/types/admin/organizations';

export const DEFAULT_ORGANIZATION_FORM_STATE = {
  name: '',
  domain: '',
  paymentAccounts: defaultOrganizationFormValues.paymentAccounts,
  entrataUsers: [] as IEntrataUser[],
};

export const DEFAULT_ORGANIZATION_ERRORS = {
  name: '',
  domain: '',
};

export const ORGANIZATION_TABS = ['Info', 'Properties', 'Users'];

